import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { loadIframeUrl, resolveVideoEmbedUrl } from '../../../../shared/utils';
import { FieldWrapper, MainfieldWrapper } from '../../common-field-styles';
import { FormContext } from '../../../shared/contexts/form-context';
import { ControlPropType } from '../../ctrl_proptype';
import Embed from './embed-field.styled';

const EmbedField = ({ ctrl }) => {
  const { inForm } = useContext(FormContext);
  const { url, height, width } = ctrl.props;
  const resolvedUrl = resolveVideoEmbedUrl(url);

  return (
    <MainfieldWrapper>
      <FieldWrapper>
        <Embed height={height} width={width && width >= 100 ? 100 : width} disabled={!inForm}>
          <iframe
            src={loadIframeUrl(resolvedUrl)}
            title="Form video"
            allowFullScreen
            id="iframe"
          />
        </Embed>
      </FieldWrapper>
    </MainfieldWrapper>
  );
};

EmbedField.propTypes = {
  ctrl: PropTypes.shape(ControlPropType).isRequired,
};

export default EmbedField;
